import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import ReadOnlyDateNoLabel
  from './Components/ReadonlyDateNoLabel';

const hiddenFields = [
  'isCompleted',
  'cannotBeActivatedDescription',
];

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride(['startDate', 'endDate'], { _component: () => ReadOnlyDateNoLabel })
  .nameOverride('createOnActivation', { _hideLabel: true })
  .nameOverride(hiddenFields, { hidden: true });
